"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeePerformanceReportSchema = exports.EmployeePerformanceRowSchema = void 0;
const zod_1 = require("zod");
exports.EmployeePerformanceRowSchema = zod_1.z.object({
    employeeId: zod_1.z.string(),
    employeeName: zod_1.z.string(),
    transactionCount: zod_1.z.number(),
    netSales: zod_1.z.number(),
    avgBasket: zod_1.z.number(),
    itemsSold: zod_1.z.number(),
    voidCount: zod_1.z.number(),
    refundCount: zod_1.z.number(),
    tipTotal: zod_1.z.number(),
    hoursWorked: zod_1.z.number().optional(),
    salesPerHour: zod_1.z.number().optional(),
    rank: zod_1.z.number().optional(),
    growthPct: zod_1.z.number().optional(),
});
exports.EmployeePerformanceReportSchema = zod_1.z.object({
    tenantId: zod_1.z.string(),
    locationId: zod_1.z.string(),
    from: zod_1.z.string(),
    to: zod_1.z.string(),
    totals: zod_1.z.object({
        totalEmployees: zod_1.z.number(),
        totalSales: zod_1.z.number(),
        totalTransactions: zod_1.z.number(),
        totalItemsSold: zod_1.z.number(),
        totalVoids: zod_1.z.number(),
        totalRefunds: zod_1.z.number(),
        totalTips: zod_1.z.number(),
    }),
    employees: zod_1.z.array(exports.EmployeePerformanceRowSchema),
});
//# sourceMappingURL=employee-performance.schema.js.map